import { FC, useEffect } from 'react';
import { Container, TextField, Box } from '@mui/material';
import { observer } from "mobx-react";
import store from "./store";
import { useTranslation } from 'react-i18next';
import { GridColDef, GridActionsCellItem } from '@mui/x-data-grid';
import { DataGrid } from '@mui/x-data-grid';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import dayjs from 'dayjs';

const MyApprovalRequestListView: FC = observer(() => {
  const { t } = useTranslation();

  useEffect(() => {
    store.loadMyRequests();
    return () => store.clearStore();
  }, []);

  const columns: GridColDef[] = [
    {
      field: 'actions',
      type: 'actions',
      width: 60,
      getActions: (params) => [
        <GridActionsCellItem
          icon={<OpenInNewIcon />}
          label="Открыть"
          onClick={() => {
            window.location.href = `/user/ApprovalRequest/addedit?id=${params.row.id}`;
          }}
        />,
      ],
    },
    {
      field: 'bga_application_number',
      headerName: 'Номер заявки',
      flex: 1.5,
      renderCell: (p) => <div>{p.row.bga_application_number}</div>,
    },
    {
      field: 'organization_name',
      headerName: 'Организация',
      flex: 2,
      renderCell: (p) => <div>{p.row.organization_name}</div>,
    },
    {
      field: 'applicant_name',
      headerName: 'Заявитель',
      flex: 2,
      renderCell: (p) => <div>{p.row.applicant_name}</div>,
    },
    {
      field: 'approval_type',
      headerName: 'Тип согласования',
      flex: 2,
      renderCell: (p) => <div>{p.row.approval_type}</div>,
    },
    {
      field: 'current_status',
      headerName: 'Статус',
      flex: 1.5,
      renderCell: (p) => <div>{p.row.current_status}</div>,
    },
    {
      field: 'received_date',
      headerName: 'Дата получения',
      flex: 1.5,
      renderCell: (p) => (
        <div>{p.row.received_date ? dayjs(p.row.received_date).format('DD.MM.YYYY') : ''}</div>
      ),
    },
    {
      field: 'deadline_date',
      headerName: 'Дедлайн',
      flex: 1.5,
      renderCell: (p) => (
        <div>{p.row.deadline_date ? dayjs(p.row.deadline_date).format('DD.MM.YYYY') : ''}</div>
      ),
    },
  ];

  return (
    <Container maxWidth='xl' sx={{ mt: 4 }}>
      <Box sx={{ mb: 2 }}>
        <TextField
          size="small"
          label="Поиск"
          value={store.searchField}
          onChange={(e) => { store.searchField = e.target.value; }}
          sx={{ width: 320 }}
        />
      </Box>
      <DataGrid
        rows={store.filteredData}
        columns={columns}
        pageSizeOptions={[25, 50, 100]}
        initialState={{ pagination: { paginationModel: { pageSize: 25 } } }}
        autoHeight
        disableRowSelectionOnClick
      />
    </Container>
  );
});

export default MyApprovalRequestListView;
